var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    { attrs: { "label-width": "130px" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "注册时间" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.registrationDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "registrationDate", $$v)
                      },
                      expression: "detailsData.registrationDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "最近登陆时间" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.loginDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "loginDate", $$v)
                      },
                      expression: "detailsData.loginDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "是否关注公众号" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.followTheOfficialAccount,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.detailsData,
                          "followTheOfficialAccount",
                          $$v
                        )
                      },
                      expression: "detailsData.followTheOfficialAccount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "是否查看公司信息" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.viewCompanyInformation,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "viewCompanyInformation", $$v)
                      },
                      expression: "detailsData.viewCompanyInformation",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("div", { staticClass: "form-title" }, [_vm._v("签到时间")]),
              _c(
                "vxe-table",
                { attrs: { data: _vm.list } },
                [
                  _c("vxe-table-column", {
                    attrs: { field: "signTime", title: "签到时间" },
                  }),
                  _c("vxe-table-column", {
                    attrs: { field: "signStats", title: "是否签到" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(row.signStats === "1" ? "是" : "否")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }